export default "__VITE_ASSET__DDMgPTSx__"